import { FluentButton } from "../../ui/fluent/fluent-component-wrapper";
import { app,pages } from "@microsoft/teams-js";
import { ConfigTabConstants, Constant } from "../../../utils/constant";
import { reactPlugin } from "../../../config/app-insights";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { useEffect, useState} from "react";
import styles from "./configuration.module.scss";
import  "../../../i18n/translation";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getGraphState } from "../../../store/graph-slice";
import { StateIndicator } from "../../../models/shared/Enums/StateIndicator";
import Loader from "../../ui/fluent/loader";
import { getAuthState } from "../../../store/auth-slice";

const Configuration = () => {
    const graphClientState = useSelector(getGraphState);
    const {graphToken}= useSelector(getAuthState);
    const {t} = useTranslation();
    const [showLoader,setShowLoader]=useState<boolean>(true);
    const saveRed = async () => {
        await app.initialize();
        pages.config.setValidityState(true);
        setShowLoader(false);
        pages.config.registerOnSaveHandler((saveEvent) => {
            const configPromise = pages.config.setConfig({
                websiteUrl: `${process.env.REACT_APP_TAB_URL}?region=${process.env.REACT_APP_TAB_REG_PRIMARY_LOC}`,
                contentUrl: `${process.env.REACT_APP_TAB_URL}?region=${process.env.REACT_APP_TAB_REG_PRIMARY_LOC}`,
                entityId: ConfigTabConstants.EntityId,
                suggestedDisplayName: ConfigTabConstants.TabName,
            });
            configPromise.
                    then((result) => {saveEvent.notifySuccess();}).
                    catch((error) => {saveEvent.notifyFailure()});
        });
    }
    
    useEffect(() => {
        if(graphToken===""||graphClientState.membersStatus===StateIndicator.Success ||graphClientState.membersStatus===StateIndicator.Failed)
        {
          
          saveRed();
        }
    },[graphClientState.membersStatus,graphToken]);

    return (
        <>        
        {showLoader?(<Loader/>):(<div className={styles.configuration_view + " d-flex align-items-center justify-content-center"}><div className="text-center">
        <img className={styles.imgbookingdesk} src={`assets/images/bookingdesk.png?region=${process.env.REACT_APP_TAB_REG_PRIMARY_LOC}`}></img>
        <p className={styles.imgbookingdesk_welcome_msg + " mb-0"}>{t('TAB_41')}</p>
        <p className={styles.imgbookingdesk_welcome_msg2 + " mb-0"}>{t('TAB_37')}</p>
        <p className={styles.imgbookingdesk_welcome_msg2 + " mb-0"}>{t('TAB_42')} <a href="https://knowledge.eptura.com/Condeco/02-End-user_guides/6-Condeco_app_for_Microsoft_Teams" target="_blank">{t("TAB_44")}</a></p>        
      </div></div>)}
      </>    
    );
};

export default withAITracking(reactPlugin, Configuration, "configuration");